import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./DetailPages.css";
import Title from "../../assets/vanocniZemekoule/title.webp";
import Picture1 from "../../assets/vanocniZemekoule/1.webp";
import Picture2 from "../../assets/vanocniZemekoule/2.webp";
import Picture3 from "../../assets/vanocniZemekoule/3.webp";
import Picture4 from "../../assets/vanocniZemekoule/4.webp";
import Picture5 from "../../assets/vanocniZemekoule/5.webp";
import Picture6 from "../../assets/vanocniZemekoule/6.webp";
import Picture7 from "../../assets/vanocniZemekoule/7.webp";
import Picture8 from "../../assets/vanocniZemekoule/8.webp";
import Picture9 from "../../assets/vanocniZemekoule/9.webp";
import Picture10 from "../../assets/vanocniZemekoule/10.webp";
import Picture11 from "../../assets/vanocniZemekoule/11.webp";
import Picture12 from "../../assets/vanocniZemekoule/12.webp";
import Picture13 from "../../assets/vanocniZemekoule/13.webp";
import Navbar from "../../components/NavBar/Navbar";
import ScrollButton from "../../components/ScrollTopButton/ScrollButton";
import ImageGalery from "../../components/ImageGalery/ImageGalery";
import Footer from "../../components/Footer/Footer";

const DetailPage = () => {
  const images = [
    { original: Picture1, thumbnail: Picture1 },
    { original: Picture2, thumbnail: Picture2 },
    { original: Picture3, thumbnail: Picture3 },
    { original: Picture4, thumbnail: Picture4 },
    { original: Picture5, thumbnail: Picture5 },
    { original: Picture6, thumbnail: Picture6 },
    { original: Picture7, thumbnail: Picture7 },
    { original: Picture8, thumbnail: Picture8 },
    { original: Picture9, thumbnail: Picture9 },
    { original: Picture10, thumbnail: Picture10 },
    { original: Picture11, thumbnail: Picture11 },
    { original: Picture12, thumbnail: Picture12 },
    { original: Picture13, thumbnail: Picture13 },
  ];

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <Navbar />
      <div className="detail-page">
        <div className="header">
          <img
            src={Title}
            alt="Header"
            className="header-image"
            loading="lazy"
          />
          <h1 className="header-title">Vánoční Zeměkoule</h1>
        </div>
        <div id="info" className="info-section">
          <p>
            Laskavé a humorné vánoční činoherní představení jednoho herce pro
            děti, které Vám spustí vánoční těšící šťávy a pohodu.
          </p>
          <p>
            Babička plete ovečky a beránky na oblohu. Beránci klidně pozorují
            všechno to dění na Zemi a také by se chtěli zapojit do toho
            vánočního veselení. Ale kam s ovečkami a beránky? No přeci… A zvonky
            cinkají a cinkají, všude klid a láska se rozhostí a už září vánoční
            hvězda…
          </p>
          <div className="short-info">
            <div className="info-item">
              <strong>Hrají:</strong> Adéla Pellarová
            </div>
            <div className="info-item">
              <strong>Scénář a režie:</strong> Adéla Pellarová
            </div>
            <div className="info-item">
              <strong>Scénografie:</strong> Adéla Pellarová
            </div>
            <div className="info-item">
              <strong>Hudba:</strong> Šimon Martínek
            </div>
            <div className="info-item">
              <strong>Kostým, výroba rekvizit a loutek:</strong> Adéla Pellarová
            </div>
            <div className="info-item">
              <strong>Výroba kulis:</strong> Petr Kubík, Míňa Podhájecká, Šárka
              Tomanová
            </div>
            <div className="info-item">
              <strong>Socha svaté rodiny:</strong> Víťa Morávková
            </div>
            <div className="info-item">
              <strong>Prostorová náročnost:</strong> Představení lze hrát ve
              třídě i na jevišti.
            </div>
            <div className="info-item">
              <strong>Produkce:</strong> Adělá Pellarová, Amálie Popelářová
            </div>
            <div className="info-item">
              <strong>Délka trvání:</strong> 40 minut
            </div>
          </div>
        </div>
        <ImageGalery images={images} h2={"foto: Petra Šplíchalová"} />
      </div>
      <ScrollButton />
      <Footer />
    </>
  );
};

export default DetailPage;
